<template>
  <div class="database">
    <template>
      <div class="theReport">
        <el-form :inline="true" :style="{height: formHeight}" label-width="100px" ref="ruleForm" size="mini">
          <el-form-item style="float: right; margin-top: -2px;">
            <el-link
              style="margin-right: 15px;"
              type="primary"
              :underline="false"
              @click="onCollapse">
              {{formHeight==='40px'?'展开':'折叠'}}
            </el-link>
            <el-button type="primary" @click="search">搜索</el-button>
            <el-button type="warning" @click="resetPage">重置</el-button>
            <el-button type="info" @click="showCustom">自定义列</el-button>
            <el-button type="warning" @click="exportSelect"><i class="iconfont" style="font-size: 12px">&#xe60b;</i>导出</el-button>
          </el-form-item>
          <el-form-item label="状态:">
            <el-select v-model="pstatusValue" @change="changeSatus" class="t-select" placeholder="请选择">
              <el-option
                v-for="item in pstatus"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="拍摄类型:">
            <el-select v-model="ptypeValue" @change="changeType" class="t-select" placeholder="请选择">
              <el-option
                v-for="item in ptype"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="SPU编码:">
            <el-input v-model.trim="spuCode" placeholder="请输入内容" />
          </el-form-item>
          <el-form-item label="SKU编码:">
            <el-input v-model.trim="skuCode" placeholder="请输入内容" />
          </el-form-item>
          <el-form-item label="SKU名称:">
            <el-input v-model.trim="skuName" placeholder="请输入内容" />
          </el-form-item>
          <el-form-item label="节点:">
            <el-select v-model="nodeCode" class="t-select" @change="changeNode"
                        placeholder="请选择">
              <el-option
                v-for="item in nodesList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
                :disabled="item.disabled">
              </el-option>
            </el-select>
          </el-form-item>
          <span class="form-date-picker">
            <el-form-item label="新品批次:">
              <el-date-picker
                v-model="pbatchStart"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="至" class="date-picker-middle">
              <el-date-picker
                v-model="pbatchEnd"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </span>
          <span class="form-date-picker">
            <el-form-item label="上新时间:">
              <el-date-picker
                v-model="addTimeStart"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="至" class="date-picker-middle">
              <el-date-picker
                v-model="addTimeEnd"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </span>
          <span class="form-date-picker">
            <el-form-item label="拍摄批次:">
              <el-date-picker
                v-model="photoBatchStart"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="至" class="date-picker-middle">
              <el-date-picker
                v-model="photoBatchEnd"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </span>
          <el-form-item label="系列:">
            <el-select v-model="seriesCode" class="t-select" placeholder="请选择">
              <el-option
                v-for="item in seriesStatusList"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <template v-if="nodeCode">
            <el-form-item label="节点状态:">
              <el-select v-model="nodeStatusCode" class="t-select" placeholder="请选择">
                <el-option
                  v-for="item in nodesStatusList"
                  :key="item.statusCode"
                  :label="item.statusName"
                  :value="item.statusCode"
                  :disabled="item.disabled">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="节点完成时间:">
              <el-date-picker
                style="width: 150px"
                v-model="nodeTimeStart"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
              <span class="t">至</span>
              <el-date-picker
                style="width: 150px"
                v-model="nodeTimeEnd"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </template>
        </el-form>


        <div class="db-table">
          <template v-if="hasData">
            <el-table
              border
              :header-cell-style="{backgroundColor: '#F4F8FB'}"
              :stripe="true"
              :data="list"
              :height="tabHeight"
              style="width: 100%"
              v-loading="loading"
              v-if="tableReload"
              id="table1">
              <template v-for="item in userCustomList">
                <el-table-column :key="item.columnName" :label="item.displayName" width="160">
                  <template slot-scope="scope">
                    <span>{{scope.row[item.columnName]}}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </template>
          <template v-else>
            <el-table
              border :stripe="true" :data="list" :height="tabHeight" style="width: 100%" v-loading="loading"
              id="table" :header-cell-style="headerHandle">
              <el-table-column
                prop="typeName"
                label="拍摄类型"
                width="160">
              </el-table-column>
              <el-table-column
                prop="spuCode"
                label="spu编码"
                width="160">
              </el-table-column>
              <el-table-column
                prop="series"
                label="系列"
                width="160">
              </el-table-column>
              <el-table-column
                prop="skuCode"
                label="sku编码"
                width="160">
              </el-table-column>
              <el-table-column
                prop="skuName"
                label="sku名称"
                :show-overflow-tooltip="true"
                width="160">
              </el-table-column>
              <el-table-column
                prop="batchNo"
                label="新品批次"
                width="160">
              </el-table-column>
              <el-table-column
                prop="addTime"
                label="上新时间"
                width="160">
              </el-table-column>
              <el-table-column
                prop="addRemark"
                label="上新备注"
                width="160">
              </el-table-column>
              <el-table-column
                prop="sampleApprovalStatus"
                label="样品评审"
                width="160">
              </el-table-column>
              <el-table-column
                prop="sampleApprovalEDate"
                label="样品评审完成时间"
                width="160">
              </el-table-column>
              <el-table-column
                prop="photoBatchStatus"
                label="拍摄批次导入"
                width="160">
              </el-table-column>
              <el-table-column
                prop="photoBatchDateCode"
                label="拍摄批次"
                width="160">
              </el-table-column>
              <el-table-column
                prop="photoBatchEDate"
                label="拍摄批次导入完成时间"
                width="160">
              </el-table-column>
              <el-table-column
                prop="scheduleDateStatus"
                label="拍摄计划"
                width="160">
              </el-table-column>
              <el-table-column
                prop="planPhotoDate"
                label="拍摄计划时间"
                width="160">
              </el-table-column>
              <el-table-column
                prop="scheduleDateEDate"
                label="拍摄计划完成时间"
                width="160">
              </el-table-column>
              <el-table-column
                prop="technicalDataStatus"
                label="技术资料"
                width="160">
              </el-table-column>
              <el-table-column
                prop="technicalDataEDate"
                label="技术资料完成时间"
                width="160">
              </el-table-column>
              <el-table-column
                prop="shootingPlanStatus"
                label="拍摄方案"
                width="160">
              </el-table-column>
              <el-table-column
                prop="shootingPlanEDate"
                label="拍摄方案完成时间"
                width="160">
              </el-table-column>
              <el-table-column
                prop="sampleGroupStatus"
                label="样品组货"
                width="160">
              </el-table-column>
              <el-table-column
                prop="sampleGroupEDate"
                label="样品组货完成时间"
                width="160">
              </el-table-column>
              <el-table-column
                prop="shootingFinishStatus"
                label="样品拍摄"
                width="160">
              </el-table-column>
              <el-table-column
                prop="shootingFinishEDate"
                label="样品拍摄完成时间"
                width="160">
              </el-table-column>
              <el-table-column
                prop="sampleReviewStatus"
                label="小样评审"
                width="160">
              </el-table-column>
              <el-table-column
                prop="sampleReviewEDate"
                label="小样评审完成时间"
                width="160">
              </el-table-column>
              <el-table-column
                prop="productArchivesStatus"
                label="产品文案"
                width="160">
              </el-table-column>
              <el-table-column
                prop="productArchivesEDate"
                label="产品文案完成时间"
                width="160">
              </el-table-column>
              <el-table-column
                prop="retouchingStatus"
                label="修片"
                width="160">
              </el-table-column>
              <el-table-column
                prop="retouchingEDate"
                label="修片完成时间"
                width="160">
              </el-table-column>
              <el-table-column
                prop="designProductPageStatus"
                label="设计页面"
                width="160">
              </el-table-column>
              <el-table-column
                prop="designProductPageEDate"
                label="设计页面完成时间"
                width="160">
              </el-table-column>
              <el-table-column
                prop="sectionStatus"
                label="切片"
                width="160">
              </el-table-column>
              <el-table-column
                prop="sectionEDate"
                label="切片完成时间"
                width="160">
              </el-table-column>
              <el-table-column
                prop="financialPricingStatus"
                label="财务定价"
                width="160">
              </el-table-column>
              <el-table-column
                prop="financialPricingEDate"
                label="财务定价完成时间"
                width="160">
              </el-table-column>
              <el-table-column
                prop="productFilesStatus"
                label="商品档案"
                width="160">
              </el-table-column>
              <el-table-column
                prop="productFilesEDate"
                label="商品档案完成时间"
                width="160">
              </el-table-column>
              <el-table-column
                prop="firstBatchPlanStatus"
                label="首批需求"
                width="160">
              </el-table-column>
              <el-table-column
                prop="firstBatchPlanEDate"
                label="首批需求完成时间"
                width="160">
              </el-table-column>
              <el-table-column
                prop="processEndStatus"
                label="商品上架"
                width="160">
              </el-table-column>
              <el-table-column
                prop="processEndEDate"
                label="商品上架完成时间"
                width="160">
              </el-table-column>
              <el-table-column
                prop="shopOnlineStatus"
                label="店铺上线"
                width="160">
              </el-table-column>
              <el-table-column
                prop="shopOnlineEDate"
                label="店铺上线完成时间"
                width="160">
              </el-table-column>

              <!--<el-table-column
                prop="name"
                label="操作">
                <a href="javascript:void(0)">查看/编辑</a>
              </el-table-column>-->
            </el-table>
          </template>
        </div>
      </div>
    </template>
    <div class="pagination">
      <el-pagination
        background
        @current-change="paging"
        :current-page="this.pageNum"
        :page-size="this.pageSize"
        :total="pageTotal"
        @size-change="pageSizeChange"
        :page-sizes="[30, 100, 500, 1000]"
        layout="total,sizes,prev, pager, next"
      ></el-pagination>
    </div>
    <el-dialog
      title="自定义展示列"
      :visible.sync="customDialog"
      :width="width"
    >
      <warmer-transfer
        ref="child"
        :reportName="reportName"
        sourcetitle="源列表"
        targettitle="目标列表"
        :key="time"
      >
      </warmer-transfer>
      <!--@listenSequence="getSubData"-->
      <div class="btn-div">
        <button class="btn" style="margin-right: 15px" @click="customDialog = false">取消</button>
        <button class="btn green" @click="saveSerialNumber">确定</button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  // import {checkTheDetails, getNewProductReport, exportReport, getNodesList, getNodesStatusList,getSeriesList} from '@/api/data'
  import WarmerTransfer from '@/views/transfer/subs/transfer'
  import moment from 'moment'
  import FileSaver from 'file-saver'
  import * as XLSX from 'xlsx'
  import HttpRequest from '../../utils/axios'
  import {baseUrl} from '../../utils/constant'
  import {Notification} from 'element-ui';
  import pagePathMixin from '@/utils/page-path-mixin'

  export default {
    name: 'theReport',
    mixins: [pagePathMixin],
    components: {
      WarmerTransfer
    },
    data() {
      return {
        width: '31.5%',
        pstatus: [
          {value: '2', label: '全部'},
          {value: '0', label: '未上架'},
          {value: '1', label: '已上架'}
        ],
        pstatusValue: '',
        ptype: [
          {value: '', label: '全部'},
          {value: '1', label: '新品'},
          {value: '2', label: '翻拍'}
        ],
        ptypeValue: '',
        spuCode: '',
        skuCode: '',
        skuName: '',
        pbatchStart: '',
        pbatchEnd: '',
        photoBatchStart: '',
        photoBatchEnd: '',
        list: [],
        pageNum: 1,
        pageSize: 30,
        pageTotal: 1,
        hasData: false,
        customDialog: false,
        reportName: null,
        loading: true,
        headers: new Map(),
        loadFlag: false,
        params: {},
        nodesList: [],
        nodesStatusList: [],
        seriesStatusList: [],
        seriesCode: '',
        nodeStatusCode: '',
        nodeCode: '',
        nodeTimeStart: '',
        nodeTimeEnd: '',
        addTimeStart: '',
        addTimeEnd: '',
        sysList: [],
        isExport: false,
        time: 1,
        formHeight: '40px',
        tableReload: true
      }
    },
    computed: {
      tabHeight() {
        if(this.formHeight === '40px') {
          return window.innerHeight - 237
        }else{
          let offsetHeight = this.$refs['ruleForm'] && this.$refs['ruleForm'].$el.offsetHeight || 0;
          return window.innerHeight - 237 - offsetHeight + 50
        }
      }
    },
    inject: ['reload'],
    watch: {
      '$route'(from, to) {
        this.init()
      },
      time(nv, ov) {
        this.time = +new Date()
      }
    },
    methods: {
      goback() {
        this.$router.go(-1)
      },
      // 自定义列查看
      saveSerialNumber() {
        this.$refs.child.saveSN('newProductReport');
        this.customDialog = false;
        this.list = [];

        this.init()
      },
      showCustom() {
        this.time++
        this.reportName = 'newProductReport';
        this.customDialog = true;

        localStorage.setItem('reportStatus', this.pstatusValue);
        localStorage.setItem('reportSpuCode', this.spuCode);
        localStorage.setItem('reportSkuCode', this.skuCode);
        localStorage.setItem('reportSkuName', this.skuName);
        localStorage.setItem('reportNewTypeCode', this.ptypeValue);
        localStorage.setItem('reportBatchDateCodeStart', this.pbatchStart);
        localStorage.setItem('reportBatchDateCodeEnd', this.pbatchEnd);
        localStorage.setItem('reportPhotoBatchDateCodeStart', this.photoBatchStart);
        localStorage.setItem('reportPhotoBatchDateCodeEnd', this.photoBatchEnd);
        localStorage.setItem('reportAddTimeStart', this.addTimeStart);
        localStorage.setItem('reportAddTimeEnd', this.addTimeEnd);
        localStorage.setItem('reportNodeTimeStart', this.nodeTimeStart);
        localStorage.setItem('reportNodeTimeEnd', this.nodeTimeEnd);
        localStorage.setItem('reportNodeStatusCode', this.nodeStatusCode);
        localStorage.setItem('reportNodeCode', this.nodeCode);
        localStorage.setItem('reportSeriesCode', this.seriesCode)
      },
      // 上次的菜单
      async checkTheDetails() {
        this.userCustomList = [];
        await this.$q.newProduct.checkTheDetails(
          {params: {moduleName: 'emall', reportName: 'newProductReport'}}
        ).then(res => {
          if (res.data.sysColumns) {
            res.data.sysColumns.forEach(item => {
              this.sysList.push(item)
            })
          }
          if (res.data.userColumns) {
            for (let i = 0; i < res.data.userColumns.length; i++) {
              this.userCustomList.push(res.data.userColumns[i])
            }
          }
          if (this.userCustomList.length === 0 || this.userCustomList.length === undefined) {
            this.hasData = false
          } else {
            this.hasData = true
          }
        })
      },
      async init() {
        if (localStorage.getItem('reportStatus')) {
          this.pstatusValue = localStorage.getItem('reportStatus')
        }
        if (localStorage.getItem('reportSpuCode')) {
          this.spuCode = localStorage.getItem('reportSpuCode')
        }
        if (localStorage.getItem('reportSkuCode')) {
          this.skuCode = localStorage.getItem('reportSkuCode')
        }
        if (localStorage.getItem('reportSkuName')) {
          this.skuName = localStorage.getItem('reportSkuName')
        }
        if (localStorage.getItem('reportNewTypeCode')) {
          this.ptypeValue = localStorage.getItem('reportNewTypeCode')
        }
        if (localStorage.getItem('reportBatchDateCodeStart')) {
          this.pbatchStart = localStorage.getItem('reportBatchDateCodeStart')
        }
        if (localStorage.getItem('reportBatchDateCodeEnd')) {
          this.pbatchEnd = localStorage.getItem('reportBatchDateCodeEnd')
        }
        if (localStorage.getItem('reportPhotoBatchDateCodeStart')) {
          this.photoBatchStart = localStorage.getItem('reportPhotoBatchDateCodeStart')
        }
        if (localStorage.getItem('reportPhotoBatchDateCodeEnd')) {
          this.photoBatchEnd = localStorage.getItem('reportPhotoBatchDateCodeEnd')
        }
        if (localStorage.getItem('reportAddTimeStart')) {
          this.addTimeStart = localStorage.getItem('reportAddTimeStart')
        }
        if (localStorage.getItem('reportAddTimeEnd')) {
          this.addTimeEnd = localStorage.getItem('reportAddTimeEnd')
        }
        if (localStorage.getItem('reportNodeTimeStart')) {
          this.nodeTimeStart = localStorage.getItem('reportNodeTimeStart')
        }
        if (localStorage.getItem('reportNodeTimeEnd')) {
          this.nodeTimeEnd = localStorage.getItem('reportNodeTimeEnd')
        }
        if (localStorage.getItem('reportNodeStatusCode')) {
          this.nodeStatusCode = localStorage.getItem('reportNodeStatusCode')
        }
        if (localStorage.getItem('reportNodeCode')) {
          this.nodeCode = localStorage.getItem('reportNodeCode')
        }
        if (localStorage.getItem('reportSeriesCode')) {
          this.seriesCode = localStorage.getItem('reportSeriesCode')
        }
        if(this.$route.query.taskId) {
          this.nodeCode = this.$route.query.taskId;
        }

        if(this.nodeCode) {
          // 默认 节点状态 设置为 “进行中”
          this.nodeStatusCode = '2';
        }

        await this.checkTheDetails();
        await this.getData()
      },

      async getData() {
        this.params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          filterData: {
            status: this.pstatusValue,
            spuCode: this.NoSpacesAllowed(this.spuCode),
            skuCode: this.NoSpacesAllowed(this.skuCode),
            skuName: this.NoSpacesAllowed(this.skuName),
            newTypeCode: this.ptypeValue,
            batchDateCodeStart: this.IsEmpty(this.pbatchStart) === null ? '' : moment(this.pbatchStart).format('YYYYMMDD'),
            batchDateCodeEnd: this.IsEmpty(this.pbatchEnd) === null ? '' : moment(this.pbatchEnd).format('YYYYMMDD'),
            photoBatchStart: this.IsEmpty(this.photoBatchStart) === null ? '' : moment(this.photoBatchStart).format('YYYYMMDD'),
            photoBatchEnd: this.IsEmpty(this.photoBatchEnd) === null ? '' : moment(this.photoBatchEnd).format('YYYYMMDD'),
            productId: this.$route.query.id,
            taskId: this.$route.query.taskId === undefined ? this.nodeCode : this.$route.query.taskId,
            addTimeStart: this.IsEmpty(this.addTimeStart) === null ? '' : moment(this.addTimeStart).format('YYYYMMDD'),
            addTimeEnd: this.IsEmpty(this.addTimeEnd) === null ? '' : moment(this.addTimeEnd).format('YYYYMMDD'),
            nodeTimeStart: this.IsEmpty(this.nodeTimeStart) === null ? '' : moment(this.nodeTimeStart).format('YYYYMMDD'),
            nodeTimeEnd: this.IsEmpty(this.nodeTimeEnd) === null ? '' : moment(this.nodeTimeEnd).format('YYYYMMDD'),
            series: this.seriesCode,
            nodeStatusCode: this.nodeStatusCode
          }

        };
        await this.$q.newProduct.getNewProductReport(
          {data: this.params}
        ).then(res => {
          if (this.isExport) {
            this.exportAction(res.data.records);
            return
          }
          this.list = res.data.records;
          this.pageNum = res.data.pageNum;
          this.pageSize = res.data.pageSize;
          this.pageTotal = res.data.total;
          this.loading = false
        });

        this.$q.newProduct.getNodesList().then(res => {
          let firstJson = {'code': '', 'name': '全部'}
          this.nodesList = res.data
          this.nodesList.unshift(firstJson)
        });

        this.$q.newProduct.getNodesStatusList().then(res => {
          let firstJson = {'statusCode': '', 'statusName': '全部'}
          this.nodesStatusList = res.data
          this.nodesStatusList.unshift(firstJson)
        });

        this.$q.newProduct.getSeriesList().then(res => {
          let firstJson = {'code': '', 'name': '全部'}
          this.seriesStatusList = res.data
          this.seriesStatusList.unshift(firstJson)
        })
      },

      changeSatus(val) {
        localStorage.setItem('reportStatus', val)
      },
      changeType(val) {
        localStorage.setItem('reportNewTypeCode', val)
      },
      changeNode() {
        if (this.nodeCode === '') {
          this.nodeTimeStart = ''
          this.nodeTimeEnd = ''
          this.nodeStatusCode = ''
        }
      },
      resetPage() {
        localStorage.clear();
        this.reload()
      },
      search: function () {
        if (this.IsEmpty(this.nodeCode) === null) {
          if (this.IsEmpty(this.nodeStatusCode) !== null || this.IsEmpty(this.nodeTimeStart) !== null || this.IsEmpty(this.nodeTimeEnd) !== null) {
            this.$message.warning('请选择节点');
            return false
          }
        }
        this.pageNum = 1;
        localStorage.setItem('reportStatus', this.pstatusValue);
        localStorage.setItem('reportSpuCode', this.spuCode);
        localStorage.setItem('reportSkuCode', this.skuCode);
        localStorage.setItem('reportSkuName', this.skuName);
        localStorage.setItem('reportNewTypeCode', this.ptypeValue);
        localStorage.setItem('reportBatchDateCodeStart', this.pbatchStart);
        localStorage.setItem('reportBatchDateCodeEnd', this.pbatchEnd);
        localStorage.setItem('reportPhotoBatchDateCodeStart', this.photoBatchStart);
        localStorage.setItem('reportPhotoBatchDateCodeEnd', this.photoBatchEnd);
        localStorage.setItem('reportAddTimeStart', this.addTimeStart);
        localStorage.setItem('reportAddTimeEnd', this.addTimeEnd);
        localStorage.setItem('reportNodeTimeStart', this.nodeTimeStart);
        localStorage.setItem('reportNodeTimeEnd', this.nodeTimeEnd);
        localStorage.setItem('reportNodeStatusCode', this.nodeStatusCode);
        localStorage.setItem('reportNodeCode', this.nodeCode);
        localStorage.setItem('reportSeriesCode', this.seriesCode);
        this.loading = true;
        if (this.$route.query.spuCode !== undefined || this.$route.query.taskId !== undefined) {
          this.$router.replace('/newProduct/theReport')
        } else {
          this.getData()
        }

      },

      paging(pageNum) {
        this.pageNum = pageNum;
        // this.search()
        this.getData()
      },
      pageSizeChange(size) {
        this.pageNum = 1;
        this.pageSize = size;
        // this.search()
        this.getData()
      },

      // 收集header key value ,  yhy
      headerHandle({row, column, rowIndex, columnIndex}) {
        let temp = Object.assign({}, column);
        this.headers.set(temp.property, temp.label)
      },
      exportSelect() {
        this.$confirm('是否选择带图片的导出？', '确认信息', {
          distinguishCancelAndClose: true,
          confirmButtonText: '是',
          cancelButtonText: '否'
        })
          .then(() => {
            this.exportReport()
          })
          .catch(action => {
            if (action === 'cancel') {
              this.exportExcel()
            } else if (action === 'close') {

            }
          });
      },
      exportReport() {
        this.params = {
          status: this.pstatusValue,
          spuCode: this.NoSpacesAllowed(this.spuCode),
          skuCode: this.NoSpacesAllowed(this.skuCode),
          skuName: this.NoSpacesAllowed(this.skuName),
          newTypeCode: this.ptypeValue,
          batchDateCodeStart: this.IsEmpty(this.pbatchStart) === null ? '' : moment(this.pbatchStart).format('YYYYMMDD'),
          batchDateCodeEnd: this.IsEmpty(this.pbatchEnd) === null ? '' : moment(this.pbatchEnd).format('YYYYMMDD'),
          photoBatchStart: this.IsEmpty(this.photoBatchStart) === null ? '' : moment(this.photoBatchStart).format('YYYYMMDD'),
          photoBatchEnd: this.IsEmpty(this.photoBatchEnd) === null ? '' : moment(this.photoBatchEnd).format('YYYYMMDD'),
          productId: this.$route.query.id,
          taskId: this.$route.query.taskId === undefined ? this.nodeCode : this.$route.query.taskId,
          addTimeStart: this.IsEmpty(this.addTimeStart) === null ? '' : moment(this.addTimeStart).format('YYYYMMDD'),
          addTimeEnd: this.IsEmpty(this.addTimeEnd) === null ? '' : moment(this.addTimeEnd).format('YYYYMMDD'),
          nodeTimeStart: this.IsEmpty(this.nodeTimeStart) === null ? '' : moment(this.nodeTimeStart).format('YYYYMMDD'),
          nodeTimeEnd: this.IsEmpty(this.nodeTimeEnd) === null ? '' : moment(this.nodeTimeEnd).format('YYYYMMDD'),
          nodeCode: this.nodeCode,
          series: this.seriesCode,
          nodeStatusCode: this.nodeStatusCode
        };

        const apiName = process.env.BUILD_ENV === 'dev' ? '' : ''
        // let res = await this.$q.preSalePlan.downloadList({ data, options: {responseType: 'blob'}})
        new HttpRequest(baseUrl).request({
          method: 'get',
          url: `${baseUrl}${apiName}ec-pc-api/arrival/exportReport`,
          responseType: 'blob',
          params: this.params
        }).then(res => {
          if (+res.status === 200) {
            let data = res.data;
            let fileReader = new FileReader();
            fileReader.onload = function () {
              try {
                let jsonData = JSON.parse(this.result);
                if (jsonData.code) {
                  // alert(jsonData.message)
                  Notification.error({
                    message: jsonData.message
                  })
                }
              } catch (e) {
                let fileName = '新品信息.xls';
                let blob = new Blob([res.data]);
                let url = window.URL.createObjectURL(blob);
                let link = document.createElement('a');
                link.style.display = 'none';
                link.href = url;
                link.setAttribute('download', decodeURI(fileName));
                document.body.appendChild(link);
                link.click()
              }
            };
            fileReader.readAsText(data)
          } else {
            Notification.error({
              message: res.message
            })
          }
        })

        // this.$q.newProduct.exportReport(
        //   {params: this.params}
        // ).then(res => {
        //   let data = res;
        //   let fileReader = new FileReader();
        //   fileReader.onload = function () {
        //     try {
        //       let jsonData = JSON.parse(res);
        //       if (jsonData.code) {
        //         alert(jsonData.message)
        //       }
        //     } catch (e) {
        //       let fileName = '新品信息.xls';
        //       let blob = new Blob([res.data]);
        //       let url = window.URL.createObjectURL(blob);
        //       let link = document.createElement('a');
        //       link.style.display = 'none';
        //       link.href = url;
        //       link.setAttribute('download', decodeURI(fileName));
        //
        //       document.body.appendChild(link);
        //       link.click()
        //     }
        //   };
        //   fileReader.readAsText(data)
        // })
      },
      // 导出文件--改从java后台导出
      exportExcel() {
        this.pageSize = 5000;
        this.pageNum = 1;
        this.isExport = true;
        this.init()
      },
      exportAction(data) {
        let pageSize = this.pageSize;
        this.exportAction = (data) => {
          // 忽略属性
          data.forEach((value) => {
            delete value.dataId;
            delete value.pictureUrl;
            let sysList = this.sysList;
            if (this.userCustomList.length > 0) {
              for (let i = 0; i < sysList.length; i++) {
                if (sysList[i].columnAttribute1 === false) {
                  let deleteColumn = sysList[i].columnName;
                  delete value[deleteColumn];
                  console.log(value)
                }
              }
            }

          });
          let sheet = XLSX.utils.json_to_sheet(data);
          // 替换英文header
          Object.keys(sheet).forEach((i) => {
            if (sheet[i].v && this.headers.has(sheet[i].v)) {
              sheet[i].v = this.headers.get(sheet[i].v)
            }
          });
          var wb1 = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb1, sheet, 'sheet1');
          // let wb = XLSX.utils.table_to_book(document.querySelector('#table'));
          /* get binary string as output */
          let wbout = XLSX.write(wb1, {bookType: 'xlsx', bookSST: true, type: 'array'});
          try {
            FileSaver.saveAs(new Blob([wbout], {type: 'application/octet-stream'}), '新品上架报表-' + (moment(new Date()).format('YYYYMMDD')) + '.xlsx');
          } catch (e) {
            console.log(e, wbout)
          } finally {
            this.isExport = false;
            this.pageSize = pageSize
          }
        };
        this.init()
      },
      onCollapse() {
        this.tableReload = false;
        this.formHeight==='40px'?this.formHeight='auto':this.formHeight='40px';
        this.$nextTick(_=>{
          this.tableReload = true;
        })
      }
    },

    mounted() {
      this.init();
      this.pname = '';
      if (window.innerWidth < 1400) {
        this.width = '44.5%'
      } else {
        this.width = '31.5%'
      }
    },

    created() {
      if (this.$route.query.spuCode) {
        this.spuCode = this.$route.query.spuCode
      }
      if (this.$route.query.batch) {
        this.photoBatchStart = moment(this.$route.query.batch).format('YYYY-MM-DD');
        this.photoBatchEnd = moment(this.$route.query.batch).format('YYYY-MM-DD')
      }
      if (this.$route.query.newProductAddTimeCode) {
        this.addTimeStart = moment(this.$route.query.newProductAddTimeCode).format('YYYY-MM-DD');
        this.addTimeEnd = moment(this.$route.query.newProductAddTimeCode).format('YYYY-MM-DD')
      }

      if (this.$route.query.photoStart) {
        this.photoBatchStart = moment(this.$route.query.photoStart).format('YYYY-MM-DD')
      }

      if (this.$route.query.photoEnd) {
        this.photoBatchEnd = moment(this.$route.query.photoEnd).format('YYYY-MM-DD')
      }

      if (this.$route.query.batchDateCodeStart) {
        this.pbatchStart = moment(this.$route.query.batchDateCodeStart).format('YYYY-MM-DD')
      }

      if (this.$route.query.batchDateCodeEnd) {
        this.pbatchEnd = moment(this.$route.query.batchDateCodeEnd).format('YYYY-MM-DD')
      }
      if (this.$route.query.status) {
        this.pstatusValue = this.$route.query.status
      } else {
        this.pstatusValue = '0'
      }
    },
    destroyed() {
      if (!(this.$route.path === '/newProduct/theReport')) {
        localStorage.removeItem('reportStatus');
        localStorage.removeItem('reportNewTypeCode');
        localStorage.removeItem('reportSpuCode');
        localStorage.removeItem('reportSkuCode');
        localStorage.removeItem('reportSkuName');
        localStorage.removeItem('reportBatchDateCodeStart');
        localStorage.removeItem('reportBatchDateCodeEnd');
        localStorage.removeItem('reportPhotoBatchDateCodeStart');
        localStorage.removeItem('reportPhotoBatchDateCodeEnd');
        localStorage.removeItem('reportAddTimeStart');
        localStorage.removeItem('reportAddTimeEnd');
        localStorage.removeItem('reportNodeTimeStart');
        localStorage.removeItem('reportNodeTimeEnd');
        localStorage.removeItem('reportNodeStatusCode');
        localStorage.removeItem('reportNodeCode');
        localStorage.removeItem('reportSeriesCode');
      }
    }

  }
</script>

<style lang="stylus" scoped>
  .database >>> .el-table td, .el-table th
    padding 6px 0
  .database >>> .is-leaf
    padding 0

  .db-table
    padding 10px
    background #ffffff
    margin-top 10px

  .theReport
    overflow hidden
    width auto
    margin 10px
    margin-bottom 0

    .t
      font-size 12px

    .ioc-button
      float left
      margin-top 2px

    .fun-tools
      float right
      margin-top -2px

      .ioc-button
        float left
        margin-top 2px
        margin-right 2px


    .left
      float left
      width 1020px
      margin-left 15px

    .right
      float right

  .btn
    display inline-block
    line-height 1
    white-space nowrap
    cursor pointer
    background #FFF
    border 1px solid #DCDFE6
    color #606266
    -webkit-appearance none
    text-align center
    -webkit-box-sizing border-box
    box-sizing border-box
    outline 0
    margin 0
    -webkit-transition 0.1s
    transition 0.1s
    font-weight 500
    -moz-user-select none
    padding 9px 20px
    font-size 12px
    border-radius 4px
    margin-top 20px

  .green
    background #0bb78e
    color #fff

  .btn-div
    width 100%
    text-align center

  .pagination
    text-align right
    background #ffffff
    width auto
    margin 10px
    margin-top 0px
    padding 10px

  // @media screen and (max-width: 1400px)
  //   .db-table
  //     margin-top 15px

  //   .theReport
  //     overflow hidden
  //     width 96%
  //     margin 20px auto

  //     .t
  //       font-size 12px

  //     .t-select
  //       width 100px
  //       padding-right 10px

  //     .fun-tools
  //       float right
  //       margin-top 1px

  //     .left
  //       float left
  //       width 960px
  //       line-height 34px
  //       margin-left 15px

  //   .btn
  //     display inline-block
  //     line-height 1
  //     white-space nowrap
  //     cursor pointer
  //     background #FFF
  //     border 1px solid #DCDFE6
  //     color #606266
  //     -webkit-appearance none
  //     text-align center
  //     -webkit-box-sizing border-box
  //     box-sizing border-box
  //     outline 0
  //     margin 0
  //     -webkit-transition 0.1s
  //     transition 0.1s
  //     font-weight 500
  //     -moz-user-select none
  //     padding 9px 20px
  //     font-size 12px
  //     border-radius 4px
  //     margin-top 20px

  //   .green
  //     background #0bb78e
  //     color #fff

  //   .btn-div
  //     width 100%
  //     text-align center

  //   .pagination
  //     margin-right 40px

  .daochu
    overflow hidden
  >>>.el-form
    background #ffffff
    padding 10px
    padding-bottom 0
    overflow hidden
  >>> .el-form-item
    margin-bottom 10px
</style>
